import React, { useState, useEffect } from 'react';
import ProjectStartDatePicker from './Overview/ProjectStartDatePicker';

export default function ProjectSettings() {
  const [constructionData, setConstructionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Load construction data including project start date
  useEffect(() => {
    const fetchConstructionData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const { fetchConstructionData } = await import('../utils/api');
        const data = await fetchConstructionData();
        
        setConstructionData(data);
      } catch (err) {
        setError('Failed to load construction data');
        console.error('Error loading construction data:', err);
      } finally {
        setLoading(false);
      }
    };
    
    fetchConstructionData();
  }, []);
  
  // Handle successful project start date update
  const handleProjectStartDateUpdate = async () => {
    try {
      setLoading(true);
      
      const { fetchConstructionData } = await import('../utils/api');
      const data = await fetchConstructionData();
      
      setConstructionData(data);
    } catch (err) {
      console.error('Error refreshing data after project start date update:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-4">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">Project Settings</h1>
          <p className="mt-2 text-sm text-gray-700">
            Configure core project parameters and global settings.
          </p>
        </div>
      </div>

      {/* Project Start Date Section */}
      <div className="mt-8">
        <div className="sm:flex sm:items-center mb-4">
          <div className="sm:flex-auto">
            <h2 className="text-lg font-semibold text-gray-900">Project Start Date</h2>
            <p className="mt-1 text-sm text-gray-500">
              Set the project start date. Changing this will shift all budget items accordingly, 
              as their timelines are defined as offsets from this date.
            </p>
          </div>
        </div>
        
        {loading ? (
          <div className="animate-pulse h-20 bg-gray-200 rounded"></div>
        ) : (
          <ProjectStartDatePicker 
            initialDate={constructionData?.project_start_date || '2025-04-01'}
            onUpdate={handleProjectStartDateUpdate}
          />
        )}
      </div>
    </div>
  );
}